/** アップロード状態定義 */
export const UploadStatus = {
  /** アップロード開始待ち */
  WAIT: 'Wait',
  /** アップロード処理待ち */
  WAITING_UPLOAD: 'WaitingUpload',
  /** アップロード中 */
  UPLOADING: 'Uploading',
  /** アップロード完了 */
  COMPLETE: 'Complete',
  /** エラー */
  ERROR: 'Error'
} as const

/** アップロード状態 */
export type UploadStatus = (typeof UploadStatus)[keyof typeof UploadStatus]

/** アップロードファイルデータ */
export interface UploadFileData {
  /** 内部管理キー（中断等に使用） */
  key: string
  /** ファイル名 */
  fileName: string
  /** ファイル */
  file: File
  /** アップロード状態 */
  status: UploadStatus
  /** アップロード進捗 */
  progress: number
  /** 完了日時 */
  completedDateTime?: Date
}

/** アップロードファイルテーブル行データ */
export interface UploadTableRow {
  /** ファイル名 */
  fileName: string
  /** 状態 */
  statusLabel: string
  /** アップロード状態 */
  status: UploadStatus
  /** 完了日時 */
  completeDateTime: string
}
